import { render } from "./DetailPrestasi.vue?vue&type=template&id=8cde691a&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./DetailPrestasi.vue?vue&type=script&lang=js"
export * from "./DetailPrestasi.vue?vue&type=script&lang=js"

import "./DetailPrestasi.vue?vue&type=style&index=0&id=8cde691a&lang=css"
script.render = render

export default script